import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCompaniesOpen, setIsCompaniesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const companies = [
    { name: 'Energiya GmbH', path: '/energiya' },
    { name: 'MYNAH GmbH', path: '/mynah' },
    { name: 'MK Immobilienverwaltung GmbH', path: '/mk' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_gruppe-osnabrueck/artifacts/bjvkd39u_69a21436-daff-4718-9fb3-cf55e72e960d.jpeg" 
              alt="immoriya" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <div 
              className="relative group"
              onMouseEnter={() => setIsCompaniesOpen(true)}
              onMouseLeave={() => setIsCompaniesOpen(false)}
            >
              <button className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 font-medium transition-colors">
                <span>Unternehmensgruppe</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              
              {isCompaniesOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-100 py-2">
                  {companies.map((company) => (
                    <Link
                      key={company.path}
                      to={company.path}
                      className="block px-4 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                    >
                      {company.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link 
              to="/kontakt" 
              className={`font-medium transition-colors ${
                location.pathname === '/kontakt' 
                  ? 'text-blue-600' 
                  : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Kontakt
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link to="/kontakt">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white px-6">
                Projekt anfragen
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-3">
            <div className="space-y-2">
              <div className="font-semibold text-gray-900 text-sm mb-2">Unternehmensgruppe</div>
              {companies.map((company) => (
                <Link
                  key={company.path}
                  to={company.path}
                  className="block pl-4 py-2 text-gray-600 hover:text-blue-600 transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {company.name}
                </Link>
              ))}
            </div>
            
            <Link
              to="/kontakt"
              className="block py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Kontakt
            </Link>

            <Link to="/kontakt" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white mt-4">
                Projekt anfragen
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
